import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Column } from './Column';

export const Grid = styled.div`
  &:after {
    content: '';
    display: table;
    clear: both;
  }

  margin-left: ${({ gutter = 0 }) => -1 * gutter}px;

  ${Column} {
    padding-left: ${({ gutter = 0 }) => gutter}px;

    ${({ gutters }) =>
      gutters &&
      gutters.length &&
      gutters.map(
        ({ breakpoint, gutter }) => `
      @media (min-width: ${breakpoint}px) {
        padding-left: ${gutter}px;
      }
    `
      )};
  }

  ${({ gutters }) =>
    gutters &&
    gutters.length &&
    gutters.map(
      ({ breakpoint, gutter }) => `
    @media (min-width: ${breakpoint}px) {
      margin-left: ${-1 * gutter}px;
    }
  `
    )};
`;

Grid.propTypes = {
  gutter: PropTypes.number,
  gutters: PropTypes.arrayOf(
    PropTypes.shape({
      breakpoint: PropTypes.number.isRequired,
      gutter: PropTypes.number.isRequired
    })
  ),
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js